import api from '../api/client';

const notificationPreferencesApi = {
  listTypes() {
    return api.get('/v1/notifications/types');
  },

  getPreferences() {
    return api.get('/v1/notifications/preferences');
  },

  updatePreference(typeId, enabled) {
    return api.patch('/v1/notifications/preferences', { typeId, enabled });
  },

  purgeExpired() {
    return api.post('/v1/notifications/expired');
  },
};

export default notificationPreferencesApi;
